/**
 * Meta Pixel — wrapper central. NENHUM componente chama window.fbq direto.
 *
 * A checagem de hostname é REDUNDANTE de propósito: o index.html já tem a
 * guarda, mas este módulo pode ser importado por uma tela que roda dentro do
 * app Android/iOS. Sem a checagem aqui, um import descuidado dispararia
 * evento de anúncio dentro do app — o que tornaria incorreto o formulário de
 * Data Safety já enviado ao Google Play (declaramos que o app não tem
 * finalidade publicitária). Duas guardas, dois arquivos, mesma regra.
 *
 * Todo disparo carrega eventID. A API de Conversões vai mandar os mesmos
 * eventos pelo servidor; sem o eventID batendo entre browser e servidor, a
 * Meta contaria cada conversão duas vezes.
 */

import { eventoGa4DaMeta } from './ga4';

const DOMINIO = 'toalugando.com.br';

const ativo = () =>
  typeof window !== 'undefined' &&
  window.location.hostname.indexOf(DOMINIO) !== -1 &&
  typeof window.fbq === 'function';

export const novoEventId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export function pageView() {
  if (!ativo()) return;
  window.fbq('track', 'PageView');
}

export function track(evento, dados = {}, eventId = novoEventId()) {
  // A mesma conversão vai pro GA4 (lib/ga4.js, com guarda própria) — antes
  // do return: bloqueador de anúncio que derruba o Pixel não pode derrubar o GA4.
  eventoGa4DaMeta(evento, dados);
  if (!ativo()) return eventId;
  window.fbq('track', evento, dados, { eventID: eventId });
  return eventId;
}

export function trackCustom(evento, dados = {}, eventId = novoEventId()) {
  if (!ativo()) return eventId;
  window.fbq('trackCustom', evento, dados, { eventID: eventId });
  return eventId;
}
